export const API_CONFIG = {
    BASE_URL: process.env.REACT_APP_API_BASE_URL,
    AUTH_URL: process.env.REACT_APP_AUTH_URL,
    CUBE_URL: process.env.REACT_APP_CUBE_API_URL,
    BASE_URL_JAVA: process.env.REACT_APP_API_JAVA_BASE_URL,
    POWERBI_URL: process.env.REACT_APP_LASTROS_POWERBI_URL,
    AWS_URL: process.env.REACT_APP_AWS_URL,
    LAMBDA_URL: process.env.REACT_APP_LAMBDA_URL,
    LIQUIDOS_URL: process.env.REACT_APP_LIQUIDOS_API_URL,
    LIQUIDOS_API_KEY: process.env.REACT_APP_LIQUIDOS_API_KEY,
  };